<template>
  <Modal>
    <Modal.Title>Add folder</Modal.Title>
    <Modal.Body>
      <Input
        v-model="name"
        size="xl"
        label="Folder name"
        :error="error"
        :disabled="loading"
        @keyup.enter="handleClick"
      />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="stroke" :disabled="loading" @click="close()">
        Cancel
      </Button>
      <Button
        variant="primary"
        :loading="loading"
        :disabled="!canSave"
        @click="handleClick"
      >
        Create
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Input, Button, useModal } from '@dacr/library'
import { useAddFolder } from './useAddFolder'

const { close } = useModal()

const props = defineProps<{
  folderId: string
  parentPath?: string
  handler?: (folder: { id: string; name: string }) => void
}>()

const { name, error, loading, canSave, handleClick } = useAddFolder(
  props,
  close
)
</script>
